import React, { useEffect, useState, useRef } from 'react'
import PropTypes from 'prop-types'

import moment from 'moment'
import CssBaseline from '@mui/material/CssBaseline'
import Box from '@mui/material/Box'
import BarChartRoundedIcon from '@mui/icons-material/BarChartRounded'
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded'
import TextSnippetOutlinedIcon from '@mui/icons-material/TextSnippetOutlined'
import VideocamIcon from '@mui/icons-material/Videocam'
import axios from 'axios'

import DateUtils from '../../inumet_js_lib/utils/dateUtils'

import {
    MapContainer,
    LayersControl,
    TileLayer,
    ImageOverlay,
    GeoJSON,
    useMapEvents,
} from 'react-leaflet'
import colormap from 'colormap'
import L from 'leaflet'
import 'leaflet-timedimension'
import 'leaflet-timedimension/dist/leaflet.timedimension.control.css'

import 'leaflet/dist/leaflet.css'
import WindLayer from '../../components/pronostico/windLayer'
import './pronosMarino.css'
import ColorScale from '../../components/maps/ColorScale'
import icon from 'leaflet/dist/images/marker-icon.png'
import iconShadow from 'leaflet/dist/images/marker-shadow.png'
import MapTimeline from '../../components/pronostico-marino/MapTimeline'
import BotonPantallaCompleta from '../../components/buttons/BotonPantallaCompleta'
import MarkersDatosPuertos from './markersDatosPuertos'
import { Fab, SpeedDial, SpeedDialAction, SpeedDialIcon } from '@mui/material'
import MeteogramasMarinoDialog from '../../components/pronostico-marino/MeteogramasMarinoDialog'
import AvisosMarinoDialog from '../../components/pronostico-marino/AvisosMarinoDialog'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@mui/material/styles'
import ReferenciasMarinoDialog from '../../components/pronostico-marino/ReferenciasMarinoDialog'

const { BaseLayer } = LayersControl

// Rutas relativas a la raíz del sitio: valen igual en desarrollo y producción.
const URL_BASE_IMAGENES = process.env.PUBLIC_URL + '/assets/img/'
const URL_FUENTE_DATOS = '/reportes/pronos_marino_auto/'

const CARPETA_CORRIDA = ':CARPETA_CORRIDA:'

const URL_DATOS_PUERTOS =
    URL_FUENTE_DATOS +
    CARPETA_CORRIDA +
    '/json/' +
    CARPETA_CORRIDA +
    '_puertos.json'

const URL_DATOS_VIENTOS =
    URL_FUENTE_DATOS +
    CARPETA_CORRIDA +
    '/json/' +
    CARPETA_CORRIDA +
    '_0:HH:_wind.json'

const TEST_URL_DATOS_OLAS2 =
    URL_FUENTE_DATOS +
    CARPETA_CORRIDA +
    '/png/' +
    CARPETA_CORRIDA +
    '_0:HH:_waves_swell_height.png'

const TEST_URL_DATOS_TEMPMAR =
    URL_FUENTE_DATOS +
    CARPETA_CORRIDA +
    '/png/' +
    CARPETA_CORRIDA +
    '_0:HH:_sea_surface_temperature.png'

const DEFAULT_HORAS_PRONOSTICO = 72
const DEFAULT_RESOLUCION_TEMPORAL_HORAS = 1
const OPACITY_DEFAULT = 0.6

let colors = colormap({
    colormap: 'jet',
    nshades: 15,
    format: 'hex',
    alpha: OPACITY_DEFAULT,
})

let colorsWind = colormap({
    colormap: 'magma',
    nshades: 10,
    format: 'hex',
    alpha: OPACITY_DEFAULT,
})

let getUrlTimeline = (indexTimeline, carpetaCorrida, url) => {
    let strIndexTimeline = indexTimeline < 10 ? '0' : ''
    let res = url.replace(
        ':HH:',
        strIndexTimeline +
        (indexTimeline < DEFAULT_HORAS_PRONOSTICO
            ? +indexTimeline
            : indexTimeline)
    )
    res = res.replace(new RegExp(CARPETA_CORRIDA, 'g'), carpetaCorrida)
    return res
}

let valAltOla = 0
const colorRanges = colors.map((c) => {
    let res = { min: valAltOla, max: valAltOla + 0.5, color: c }
    valAltOla > 5 ? (valAltOla += 1) : (valAltOla += 0.5)
    return res
})
//colorRanges[colors.length - 1].max = ''

const colorRangesTempMar = [
    { min: 0.0, max: 1.5, color: '#0000a4' },
    { min: 1.5, max: 3.0, color: '#0000ed' },
    { min: 3.0, max: 4.5, color: '#0020ff' },
    { min: 4.5, max: 6.0, color: '#0060ff' },
    { min: 6.0, max: 7.5, color: '#00a0ff' },
    { min: 7.5, max: 9.0, color: '#00e0fb' },
    { min: 9.0, max: 10.5, color: '#30ffc7' },
    { min: 10.5, max: 12.0, color: '#63ff94' },
    { min: 12.0, max: 13.5, color: '#97ff60' },
    { min: 13.5, max: 15.0, color: '#caff2c' },
    { min: 15.0, max: 16.5, color: '#feed00' },
    { min: 16.5, max: 18.0, color: '#ffb200' },
    { min: 18.0, max: 19.5, color: '#ff7700' },
    { min: 19.5, max: 21.0, color: '#ff3b00' },
    { min: 21.0, max: 22.5, color: '#e80000' },
    { min: 22.5, max: 24.0, color: '#9f0000' },
]

/* 
id     col                    title
0     #0000a4		0.00-1.50 
1     #0000ed		1.50-3.00 
2     #0020ff		3.00-4.50 
3     #0060ff		4.50-6.00 
4     #00a0ff		6.00-7.50 
5     #00e0fb		7.50-9.00 
6     #30ffc7		9.00-10.50 
7     #63ff94		10.50-12.00
8     #97ff60		12.00-13.50
9     #caff2c		13.50-15.00
10    #feed00		15.00-16.50
11    #ffb200		16.50-18.00
12    #ff7700		18.00-19.50
13    #ff3b00		19.50-21.00
14    #e80000		21.00-22.50
15    #9f0000		22.50-24.00


*/

const centroMapa = [-35.01667, -55]

let DefaultIcon = L.icon({
    iconUrl: icon,
    iconAnchor: [12, 41],
    shadowUrl: iconShadow,
})

L.Marker.prototype.options.icon = DefaultIcon

const CANT_MAPAS_VIENTO = 8
let mapasViento = new Array(CANT_MAPAS_VIENTO).fill(null)

const latMin = -50.0
const latMax = -30.0
const lonMin = -60.0
const lonMax = -30.25

// Crear un LatLngBounds en Leaflet
const bounds = [
    [latMin, lonMin],
    [latMax, lonMax],
]

const GeoJSONLayer = ({ geojson }) => {
    const onEachFeature = (feature, layer) => {
        if (feature.properties && feature.properties.nombre) {
            layer.bindPopup(`<p>${feature.properties.nombre}</p>`)
        }
    }

    return <GeoJSON data={geojson} onEachFeature={onEachFeature} />
}

export default function PronosticoMarino() {
    const [dataPuertos, setDataPuertos] = useState({})
    const [dataAvisos, setDataAvisos] = useState(null)
    const [nombreCarpetaCorrida, setNombreCarpetaCorrida] = useState('')
    const [loadingViento, setLoadingViento] = useState(true)
    const [indexTimeline, setIndexTimeline] = useState(0)
    const [meteogramasMarinoVisible, setMeteogramasMarinoVisible] =
        useState(false)
    const [avisosMarinoVisible, setAvisosMarinoVisible] = useState(false)
    const [refMarinoVisible, setRefMarinoVisible] = useState(false)
    const [geojsonRegiones, setGeojsonRegiones] = useState(null)
    useEffect(() => {
        fetch(URL_FUENTE_DATOS + 'regiones/regiones.geojson')
            .then((response) => response.json())
            .then((data) => setGeojsonRegiones(data))
    }, [])

    let fechaIniPronos = ''
    let mapRef = useRef()

    let [indexLayerVisible, setIndexLayerVisible] = useState(0)
    const MapEventHandler = () => {
        useMapEvents({
            baselayerchange: (event) => {
                if (event.name === 'Temp. Sup. Mar') setIndexLayerVisible(1)
                else setIndexLayerVisible(0)
            },
        })

        return null
    }

    const theme = useTheme()
    const mcel = useMediaQuery(theme.breakpoints.down('md'))

    let getUltFechaCorrida = (fechaActualUTC) => {
        let fechaActualUTCAux = fechaActualUTC.clone()
        fechaActualUTCAux.set('minute', 0)
        let hora = Number.parseInt(DateUtils.getHour(fechaActualUTC))
        if (hora >= 22 || hora < 4) {
            fechaActualUTCAux.set('hour', 18)
            fechaActualUTCAux = DateUtils.addDays(fechaActualUTCAux, -1)
        } else if (hora < 10) {
            fechaActualUTCAux.set('hour', 0)
        } else if (hora < 16) {
            fechaActualUTCAux.set('hour', 6)
        } else if (hora < 22) {
            fechaActualUTCAux.set('hour', 12)
        }
        return fechaActualUTCAux
    }

    useEffect(() => {
        let fechaActual = DateUtils.nowUTC()
        consultarDatosPuertos(fechaActual)
        consultarDatosAvisos()
    }, [])

    useEffect(() => {
        if (nombreCarpetaCorrida !== '') {
            let promises = []
            for (let i = 0; i < DEFAULT_HORAS_PRONOSTICO; i++) {
                promises.push(consultarDatosViento(i))
            }
        }
    }, [nombreCarpetaCorrida])

    const consultarDatosViento = async (index) => {
        let urlDatos = getUrlTimeline(
            index,
            nombreCarpetaCorrida,
            URL_DATOS_VIENTOS
        )
        return axios
            .get(urlDatos)
            .then((response) => {
                mapasViento[index] = response.data
                setLoadingViento(false)
                return
            })
            .catch((err) => {
                console.log(err)
                setLoadingViento(false)
                return
            })
    }

    let getNombreCarpeta = (fecha) => {
        let hora = fecha.get('hour')
        if (hora < 10) hora = '0' + hora
        let formattedDate = fecha.format('YYYYMMDD')

        return formattedDate + '_' + hora
    }
    const consultarDatosPuertos = (fecha, cantIntentos) => {
        if (cantIntentos === undefined) cantIntentos = 0
        let fechaCorrida = getUltFechaCorrida(fecha)
        let nomCarpetaCorrida = getNombreCarpeta(fechaCorrida)
        let urlDatosPuertos = URL_DATOS_PUERTOS.replace(
            new RegExp(CARPETA_CORRIDA, 'g'),
            nomCarpetaCorrida
        )
        return axios
            .get(urlDatosPuertos)
            .then((response) => {
                if (
                    response.data &&
                    response.data.puertos &&
                    response.data.puertos.length > 0
                ) {
                    setNombreCarpetaCorrida(nomCarpetaCorrida)
                }
                setDataPuertos(response.data)
                return
            })
            .catch((err) => {
                if (process.env.NODE_ENV === 'development')
                    console.log(
                        'Intento ' +
                        cantIntentos +
                        ' ' +
                        err +
                        '. URL: ' +
                        urlDatosPuertos
                    )
                if (cantIntentos < 10) {
                    cantIntentos++
                    return consultarDatosPuertos(
                        DateUtils.addHours(fecha, -6),
                        cantIntentos
                    )
                }
            })
    }

    const consultarDatosAvisos = () => {
        return axios
            .get(URL_FUENTE_DATOS + 'aviso-marino.json')
            .then((response) => {
                if (response.data) {
                    if (response.data) {
                        setDataAvisos(response.data)
                    }
                }
                return
            })
            .catch((err) => {
                console.log(err)
            })
    }

    let timeInterval = ''
    if (dataPuertos && dataPuertos.puertos) {
        fechaIniPronos = DateUtils.parseDate(dataPuertos.corrida)
        timeInterval =
            fechaIniPronos.format('YYYY-MM-DDTHH:mmZ') +
            '/' +
            DateUtils.addHours(fechaIniPronos, DEFAULT_HORAS_PRONOSTICO).format(
                'YYYY-MM-DDTHH:mmZ'
            )
    }

    return (
        <React.Fragment>
            <CssBaseline />

            <Box sx={{ height: 'calc(100vh - env(safe-area-inset-bottom))' }}>
                {dataPuertos && dataPuertos.puertos && (
                    <MapContainer
                        className="p-0"
                        ref={mapRef}
                        style={{
                            width: '100%',
                            height: '100%',
                        }}
                        center={centroMapa}
                        zoom={8}
                        zoomControl={!mcel}
                        scrollWheelZoom={true}
                        whenReady={(map) => {
                            mapRef.current = map
                            document.querySelector(
                                '.timecontrol-date'
                            ).innerHTML =
                                moment(fechaIniPronos).format('DD/MM H[hrs]')
                        }}
                        timeDimension={true}
                        timeDimensionOptions={{
                            timeInterval: timeInterval,
                            period: 'PT1H',
                            currentTime: fechaIniPronos,
                        }}
                        timeDimensionControl={true}
                        timeDimensionControlOptions={{
                            limitSliders: false,
                            timeZones: ['Local'],
                            speedSlider: false,
                            timeSliderDragUpdate: true,
                            displayDate: true,
                            position: 'bottomleft',
                            playerOptions: {
                                playButton: false,
                                transitionTime: 3000,
                            },
                            dateFormat: 'MM/DD hHH',
                        }}
                    >
                        {/*
                            Columna izquierda, de arriba hacia abajo:
                            zoom (solo escritorio, y=10..74), pantalla completa
                            y el menu +. Se reserva el alto del zoom aunque en
                            movil no se renderice, para no taparlo nunca.
                        */}
                        <Box
                            sx={{
                                position: 'absolute',
                                top: 84,
                                left: 10,
                                zIndex: 1000,
                            }}
                        >
                            <BotonPantallaCompleta texto={false} />
                        </Box>
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                gap: '16px',
                                marginTop: '1em',
                            }}
                        >
                            {!mcel && (
                                <>
                                    <Fab
                                        variant="extended"
                                        size="medium"
                                        color="primary"
                                        onClick={() => {
                                            setMeteogramasMarinoVisible(true)
                                        }}
                                    >
                                        <BarChartRoundedIcon className="mr-1" />
                                        Meteogramas
                                    </Fab>
                                    <Fab
                                        variant="extended"
                                        size="medium"
                                        color="primary"
                                        onClick={() => {
                                            setAvisosMarinoVisible(true)
                                        }}
                                    >
                                        <ErrorOutlineRoundedIcon className="mr-1" />
                                        Avisos
                                    </Fab>
                                    <Fab
                                        variant="extended"
                                        size="medium"
                                        color="primary"
                                        onClick={() => {
                                            setRefMarinoVisible(true)
                                        }}
                                    >
                                        <TextSnippetOutlinedIcon className="mr-1" />
                                        Info
                                    </Fab>
                                    <a href="https://www.youtube.com/watch?v=xtwPhXG9sLo">
                                        <Fab
                                            variant="extended"
                                            size="medium"
                                            color="primary"
                                        >
                                            <VideocamIcon className="mr-1" />
                                            Guía de Uso
                                        </Fab>
                                    </a>
                                </>
                            )}

                            {mcel && (
                                <>
                                    <SpeedDial
                                        ariaLabel="Menú"
                                        direction="down"
                                        sx={{
                                            position: 'absolute',
                                            top: 148,
                                            left: 10,
                                            '& .MuiFab-primary': {
                                                backgroundColor: '#00897b',
                                                '&:hover': {
                                                    backgroundColor: '#00897b',
                                                },
                                            },
                                            // Sin esto las etiquetas se parten
                                            // en varias lineas y se pisan.
                                            '& .MuiSpeedDialAction-staticTooltipLabel':
                                                {
                                                    whiteSpace: 'nowrap',
                                                },
                                        }}
                                        icon={<SpeedDialIcon />}
                                    >
                                        <SpeedDialAction
                                            key={'meteogramas'}
                                            icon={<BarChartRoundedIcon />}
                                            tooltipTitle={'Meteogramas'}
                                            onClick={() => {
                                                setMeteogramasMarinoVisible(
                                                    true
                                                )
                                            }}
                                            tooltipOpen
                                            tooltipPlacement="right"
                                        />
                                        <SpeedDialAction
                                            key={'avisos'}
                                            icon={<ErrorOutlineRoundedIcon />}
                                            tooltipTitle={'Avisos'}
                                            onClick={() => {
                                                setAvisosMarinoVisible(true)
                                            }}
                                            tooltipOpen
                                            tooltipPlacement="right"
                                        />

                                        <SpeedDialAction
                                            key={'notas'}
                                            icon={<TextSnippetOutlinedIcon />}
                                            tooltipTitle={'Notas'}
                                            onClick={() => {
                                                setRefMarinoVisible(true)
                                            }}
                                            tooltipOpen
                                            tooltipPlacement="right"
                                        />

                                        <SpeedDialAction
                                            key={'video'}
                                            icon={<VideocamIcon />}
                                            tooltipTitle={'Guía de Uso'}
                                            tooltipOpen
                                            tooltipPlacement="right"
                                            onClick={() => {
                                                window.location.href =
                                                    'https://www.youtube.com/watch?v=xtwPhXG9sLo'
                                            }}
                                        />
                                    </SpeedDial>
                                </>
                            )}
                        </div>
                        )
                        <MapTimeline
                            onLoad={(data) => {
                                let newIndex =
                                    data.sourceTarget._loadingTimeIndex %
                                    DEFAULT_HORAS_PRONOSTICO
                                if (mapasViento[newIndex]) {
                                    setIndexTimeline(newIndex)
                                }
                            }}
                        />
                        <LayersControl collapsed={false} position="topright">
                            <MapEventHandler />
                            <TileLayer
                                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                            />
                            {geojsonRegiones && (
                                <LayersControl.Overlay
                                    checked={false}
                                    name="Regiones"
                                >
                                    <GeoJSONLayer geojson={geojsonRegiones} />
                                </LayersControl.Overlay>
                            )}
                            {!loadingViento && (
                                <LayersControl.Overlay
                                    checked={true}
                                    name="Vientos en superficie"
                                >
                                    <WindLayer
                                        displayValues={true}
                                        displayOptions={{
                                            velocityType: '',
                                            displayPosition: 'bottomright',
                                            displayEmptyString:
                                                'No hay datos disponibles',
                                            emptyString:
                                                'Sin datos disponibles para esta ubicación',
                                            speedUnit: 'kt',
                                            directionString: 'Dirección',
                                            particleSize: 5,
                                            // speed label prefix
                                            speedString: 'Intensidad',
                                        }}
                                        data={mapasViento[indexTimeline]}
                                        maxVlocity={10}
                                        minVelocity={0}
                                        opacity={1}
                                        colorScale={colorsWind}
                                    />
                                </LayersControl.Overlay>
                            )}
                            {nombreCarpetaCorrida !== '' && (
                                <BaseLayer
                                    checked={indexLayerVisible === 0}
                                    name="Alt. de Olas"
                                >
                                    <ImageOverlay
                                        url={getUrlTimeline(
                                            indexTimeline,
                                            nombreCarpetaCorrida,
                                            TEST_URL_DATOS_OLAS2
                                        )}
                                        bounds={bounds}
                                        opacity={OPACITY_DEFAULT}
                                    />
                                </BaseLayer>
                            )}
                            {nombreCarpetaCorrida !== '' && (
                                <BaseLayer
                                    checked={indexLayerVisible === 1}
                                    name="Temp. Sup. Mar"
                                >
                                    <ImageOverlay
                                        url={getUrlTimeline(
                                            indexTimeline,
                                            nombreCarpetaCorrida,
                                            TEST_URL_DATOS_TEMPMAR
                                        )}
                                        bounds={bounds}
                                        opacity={OPACITY_DEFAULT}
                                    />
                                </BaseLayer>
                            )}
                            <MarkersDatosPuertos
                                dataPuertos={dataPuertos}
                                horasPronostico={DEFAULT_HORAS_PRONOSTICO}
                                resolucionTemporal={
                                    DEFAULT_RESOLUCION_TEMPORAL_HORAS
                                }
                                center={centroMapa}
                            />
                            {indexLayerVisible === 0 && (
                                <ColorScale
                                    ranges={colorRanges}
                                    title={''}
                                    opacity={OPACITY_DEFAULT + 0.4}
                                />
                            )}
                            {indexLayerVisible === 1 && (
                                <ColorScale
                                    ranges={colorRangesTempMar}
                                    title={
                                        'TEMP MAR ' +
                                        String.fromCharCode(176) +
                                        'C'
                                    }
                                    opacity={OPACITY_DEFAULT + 0.4}
                                />
                            )}
                        </LayersControl>
                    </MapContainer>
                )}
                <MeteogramasMarinoDialog
                    dataPuertos={dataPuertos}
                    horasPronostico={DEFAULT_HORAS_PRONOSTICO}
                    horasResolTemporal={DEFAULT_RESOLUCION_TEMPORAL_HORAS}
                    open={meteogramasMarinoVisible}
                    handleClose={() => {
                        setMeteogramasMarinoVisible(false)
                    }}
                    pathPrefixLogo={URL_BASE_IMAGENES}
                />
                <AvisosMarinoDialog
                    dataAvisos={dataAvisos}
                    open={avisosMarinoVisible}
                    pathPrefixLogo={URL_BASE_IMAGENES}
                    handleClose={() => {
                        setAvisosMarinoVisible(false)
                    }}
                />
                <ReferenciasMarinoDialog
                    open={refMarinoVisible}
                    pathPrefixLogo={URL_BASE_IMAGENES}
                    handleClose={() => {
                        setRefMarinoVisible(false)
                    }}
                />
            </Box>
        </React.Fragment>
    )
}

GeoJSONLayer.propTypes = {
    geojson: PropTypes.object,
}
